import React from "react";

import ApplicantsCounter from "./ApplicantsCounter"
import CommunityMeta from "./CommunityMeta";
import SendMeButton from "./SendMeButton";
import CardImage from "./CardImage";
  

export default function CommunityUnified({community, name,desc,strapiCommunityID,bucket,id,email,hubspotId}){
    
    const affiliation = community.attributes.affiliation;
    const location = community.attributes.training_location

    return(
        <article id={'community-'+community.attributes.slug} className={"community-card unified "} key={strapiCommunityID}>
            {location && 
            <div className="location-tag">
                <div className="location-tag__label">Training Location:</div>
                <div className="location-tag__text">
                    {location}
                    <span className="location-tag__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.327" height="17.811" viewBox="0 0 16.327 17.811">
                            <path id="Path_3" data-name="Path 3" d="M13.987,1.484a1.9,1.9,0,0,1,1.855,1.806c0,1.008-.775,2.451-1.855,4.247-1.081-1.8-1.855-3.239-1.855-4.247a1.9,1.9,0,0,1,1.855-1.806Zm0-1.484a3.376,3.376,0,0,0-3.34,3.291c0,1.818,1.448,3.987,3.34,7.1,1.892-3.112,3.34-5.281,3.34-7.1A3.376,3.376,0,0,0,13.987,0Zm0,4.453A1.113,1.113,0,1,1,15.1,3.34,1.114,1.114,0,0,1,13.987,4.453ZM8.6,5.371c0-.007-.214-.013-.178-.058l.1-.063a.26.26,0,0,0-.006-.226l.035-.093-.074.022s.1-.45.245-.246l-.059.069a1.039,1.039,0,0,1,.145.462c.085.045.219.053.065.13.079-.013-.416.212-.481.119C8.344,5.431,8.607,5.393,8.6,5.371Zm-.531-.118c-.058.058,0,.095.061.07.084-.037.2-.036.21-.15l.055-.068c.023-.036-.046-.094-.076-.1s-.074.047-.1.071l-.049.013-.046.059.006.033Zm5.195,6.8-.545-.895-.537-.88c-.542-.886-1.031-1.689-1.455-2.446l-.052.05c-.28.116-.7-.378-.994-.394.143.022.013-.364.013-.389-.113-.14-.833.016-1.022.041a1.908,1.908,0,0,0-1,.263c-.191.156-.194.409-.39.531-.126.079-.263.053-.373.155a2.448,2.448,0,0,0-.517.689c-.045.1.058.34.032.469a1.482,1.482,0,0,0,1.02,2c.232.029.474.155.709.085a2.637,2.637,0,0,1,.554-.2c.28-.019.163.393.546.281.187-.055.271.128.271.266-.062.29-.2.452.065.655a.9.9,0,0,1,.361.579c.02.135.146.367-.01.447-.111.056-.193.376-.191.482.023.122.271.357.347.461.108.148.029.324.117.492a3.941,3.941,0,0,1,.239.479c.082.24.712-.005.858,0,.5,0,.753-.7,1.1-.917.2-.122.142-.457.378-.629.219-.16.45-.255.471-.55.016-.255-.191-.788-.077-1l.076-.122ZM7.845,6.3a2.069,2.069,0,0,1-.114.59c-.023.1.329.168.309.219,0-.006.476-.163.523-.2l.106-.24a1.328,1.328,0,0,1,.286-.145l.122-.212a3.468,3.468,0,0,1,.561-.075,1.842,1.842,0,0,1,.432.394l.03.024a11.341,11.341,0,0,1-.59-1.441l-.062.027a.87.87,0,0,0-.491.3,1.832,1.832,0,0,1-.543.245c.245.026.233.2.213.358C8.575,6.49,7.813,6.163,7.845,6.3Zm8.092,3.747a6.789,6.789,0,0,1-11.687,4.3c-.146-.154-.257-.519-.015-.668l.246-.063c.191-.163-.18-.824-.033-.931.458-.327.24-.729-.041-1.06-.119-.141-.774-.816-.848-.7a1.524,1.524,0,0,0-.223-.807,3.465,3.465,0,0,1-.5-.8C2.8,9.187,2.8,8.795,2.719,8.7c-.03-.037-.266-.137-.258-.191A6.773,6.773,0,0,1,4.216,4.987l.608-.245c.383-.574.4-.128.748-.278.114,0,.246-.471.368-.545.214-.137.05-.137.012-.2a4.523,4.523,0,0,1,1.82-.7c.024.1-.928.6-.823.585-.241.032-.287.465-.243.464.12,0,.877-.574,1.229-.453s.965-.275,1.207-.475l.031-.029A4.606,4.606,0,0,1,9.53,1.5l-.367-.019a8.159,8.159,0,1,0,7.995,6.509c-.364.641-.774,1.32-1.222,2.05Z" transform="translate(-1)"/>
                        </svg>
                    </span>
                </div>
            </div>
            }
            
            <div className="community__image">
                <CardImage community={community} />
                <div className="name-affiation-wrapper mobile-only">
                    <div className="name-wrapper">
                        <div className="com-name-label com-label">
                            Missional Community:
                        </div>
                        <div className="community__name">{name}</div>
                    </div>
                    {affiliation && 
                    <div className="affiliation-wrapper">
                        <div className="com-affiliation-label com-label">
                            Affiliation:
                        </div>
                        <div className="community__affiliation">{affiliation}</div>
                    </div>
                    }
                </div>
            </div>
            <div className="community__info">
                <div className="name-affiation-wrapper hide-below-tablet">
                    <div className="name-wrapper">
                        <div className="com-name-label com-label">
                            Missional Community:
                        </div>
                        <div className="community__name">{name}</div>
                    </div>
                    {affiliation && 
                    <div className="affiliation-wrapper">
                        <div className="com-affiliation-label com-label">
                            Affiliation:
                        </div>
                        <div className="community__affiliation">{affiliation}</div>
                    </div>
                    }
                </div>
                
                <div className="community__desc">{desc}</div>
                {/* <CommunityMeta community={community.attributes} /> */}
                <ApplicantsCounter bucket={bucket} community={community.attributes} />
                <SendMeButton btnText={'Send Me'} email={email} hubspotId={hubspotId} id={id} successUrl={'/arenas-success'} />
            </div>
        </article>
    )
}